import React , { useEffect , useState } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { UserProvider , useUser } from '../../context/UserContext'; 
import { ProviderCompanyProvider  } from '../../context/ProviderCompanyContext'; 
import { register , login } from "../../services/userService";

const ProtectedRouteComponent = ({ component: Component, ...rest }) => {
  const { userInfoReady, userInfo } = useUser();
  const [loadingAuthUrl, setLoadingAuthUrl] = useState(false);


  const providerCompanyId = rest.match.params.providerCompanyId;

  useEffect(() => {
    if (!userInfoReady) return;

    if (!userInfo) {
      const initiateLogin = async () => {
        try {
          setLoadingAuthUrl(true);
          const resp = await login();
          window.location.href = resp.data.authUrl;
        } catch (error) {
          // Login initiation failed
        } finally {
          setLoadingAuthUrl(false);
        }
      };

      initiateLogin();
    }
  }, [userInfoReady, userInfo]);

  if (!userInfoReady || loadingAuthUrl) {
    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
        <div className="flex flex-col items-center">
          <div className="w-12 h-12 border-4 border-t-primary rounded-full animate-spin mb-4"></div>
          <span className="text-white">loading...</span>
        </div>
      </div>
    );
  }

  if (!userInfo) {
    return null; // Return null to avoid rendering anything while redirecting
  }

  return <Component {...rest} />;
};

const ProtectedRoute = ({ component, ...rest }) => (
  // <UserProvider>
  //     <Route {...rest} render={props => <ProtectedRouteComponent component={component} {...props} />} />
  // </UserProvider>
  <UserProvider>
    <ProviderCompanyProvider>
      <Route {...rest} render={props => <ProtectedRouteComponent component={component} {...props} />} />
    </ProviderCompanyProvider>
  </UserProvider>
);

export default ProtectedRoute;